const collection = {
    slug: "maison-margiela-number-tag-guide",
    metaTitle:
      "Maison Margielaタグ番号の意味｜マルジェラ数字タグ完全解説と買取ガイド",
    metaDescription:
      "Maison Margielaのタグ番号の意味を知りたい方へ。0 Artisanal、1ウィメンズ、4ワードローブ、6 MM6、10メンズ、14メンズワードローブ、22シューズに加え、1と10など複数番号に丸が付くタグ、番号プリントのない白タグまで解説。本人期・アーティザナル・Tabi・5ACなどの買取相談にもつながるEnclopediaの完全ガイドです。",
    metaKeywords:
      "マルジェラ タグ 番号,メゾンマルジェラ タグ 数字 意味,Maison Margiela 番号 意味,Maison Margiela タグ,マルジェラ 数字タグ,マルジェラ 白タグ,マルジェラ 真っ白 タグ,マルジェラ 番号なし タグ,マルジェラ 1 10 丸,マルジェラ 複数番号 丸,マルジェラ 0 意味,マルジェラ 1 意味,マルジェラ 4 意味,マルジェラ 6 意味,マルジェラ 10 意味,マルジェラ 14 意味,マルジェラ 22 意味,マルジェラ 10 14 違い,Maison Martin Margiela タグ,マルジェラ 本人期 タグ,マルジェラ アーティザナル,マルジェラ 買取,メゾンマルジェラ 買取,マルジェラ アーカイブ 買取,Enclopedia,アンクロペディア",
    canonicalPath: "/archive_collection/maison-margiela-number-tag-guide",
    heroImage: "media/archive_fashion/archive4.png",
    heroImageAlt:
      "Maison Margielaの数字タグとライン番号の意味を解説するEnclopediaアーカイブガイド画像",
    heroNumber: "04 / NUMBER TAG",
    label: "ARCHIVE BRAND GUIDE",
    title: "Maison Margiela タグ番号完全解説",
    lead:
      "Maison Margielaの白いタグに並ぶ、0から23までの数字。\n一見すると暗号のように見えますが、丸で囲まれた番号は、そのアイテムがどのラインやカテゴリーに属するかを示しています。\nただし、マルジェラのタグは単純な一覧表だけでは読み切れません。\n1と10のように複数番号に丸が付くもの、番号プリントがなく白く見えるタグのもの、旧Maison Martin Margiela期の仕様など、年代やラインによって例外も存在します。\nタグ番号を読めるようになると、その服が“ただのブランド品”ではなく、どの文脈にある一着なのかが見えてきます。",
    keywordLine: [
      "number tag",
      "maison margiela",
      "white tag",
      "buyback guide",
    ],
    thesis:
      "Maison Margielaの数字タグは、ラインを分類するための記号であると同時に、匿名性・構造・アーカイブ価値を読み解く入口です。",
    whyTitle:
      "マルジェラのタグ番号は、なぜここまで気になるのか。",
    whyBody:
      "Maison Margielaのタグは、ブランド名を大きく見せるためのものではありません。\n白い布、四隅のステッチ、0から23までの数字。その控えめな表示の中に、ブランドの匿名性と分類の思想が詰まっています。\nさらに、数字タグ導入以前の無地の白タグ、現在・近年品にも見られる番号プリントのない白タグ、複数番号に丸が付くタグ、0 10のようにArtisanalとメンズを横断する表示など、タグそのものが年代やラインを読む手がかりになります。\nただし、タグ仕様は例外も多いため、白タグ＝初期、白タグ＝高額、白タグ＝偽物とは断定できません。\n特に古着やアーカイブでマルジェラを探すとき、タグ番号は“どのラインの服なのか”“本人期やアーティザナルに近い文脈なのか”“メンズなのかワードローブなのか”を判断する入口になります。\nそして買取においても、タグ番号・年代・ライン・状態は査定の重要な情報になります。",
    pillars: [
      {
        number: "01",
        title: "NUMBER AS LINE",
        text:
          "丸で囲まれた番号は、そのアイテムが属するラインやカテゴリーを示します。0、1、4、6、10、14、22など、数字ごとに意味が異なります。",
      },
      {
        number: "02",
        title: "EXCEPTION AS CLUE",
        text:
          "複数番号に丸が付くタグ、0 10表記、番号プリントのない白タグなど、例外的なタグ仕様は年代やラインを読む重要な手がかりになります。",
      },
      {
        number: "03",
        title: "TAG AS VALUE CLUE",
        text:
          "買取やアーカイブ評価では、タグ番号だけで価値が決まるわけではありません。ただし、ライン・年代・アイテム種別を判断する入口として重要です。",
      },
    ],
    readingTitle:
      "0から23まで。Maison Margielaの数字タグを読む。",
    readingIntro:
      "数字タグは、単なるデザインではなく、Maison Margielaのライン構造を知るための地図です。ただし、白タグ、複数番号に丸が付くタグ、0 10表記など、例外も含めて読むことで、より実物に近い理解になります。",
    observations: [
      {
        index: "PRE",
        title:
          "番号プリントのない白タグ｜初期仕様だけでなく、近年品にも見られる例外タグ",
        text:
          "Maison Margielaのタグといえば、0から23までの数字が並んだ白タグを思い浮かべる人が多いですが、番号プリントがない、または表面上は真っ白に見える白タグも存在します。\n初期Maison Martin Margielaでは、数字タグ導入以前の無地タグが匿名性を象徴する重要な仕様として知られています。\n一方で、現在・近年のMaison Margielaでも、ランウェイピースや一部ライン、サンプル、仕様違いなどで無地に近い白タグが見られることがあります。\nそのため、白タグだから初期、白タグだから高額、白タグだから偽物、とは判断できません。\n買取視点：番号のない白タグは、年代・ライン・品質表示・縫製・素材・購入経路を合わせて確認する必要があります。LINE査定では、首元タグ、品質表示、全体写真、ディテール写真を必ず送るのがおすすめです。",
      },
      {
        index: "MIX",
        title:
          "複数番号に丸が付くタグ｜1と10、0と10など複数ラインを横断する表示",
        text:
          "Maison Margielaの数字タグでは、基本的に丸で囲まれた番号がラインを示します。ただし、アイテムによっては複数の番号に丸が付く場合があります。\nたとえばウィメンズとメンズの文脈を横断するようなもの、Artisanalとメンズを示す0 10のような表記など、単一番号だけでは説明しきれない仕様があります。\n買取視点：複数番号に丸がある場合は、通常のライン判定よりも慎重に見る必要があります。1と10が両方丸で囲まれている場合も、ユニセックス的な企画、ライン横断、年代特有の仕様、あるいは真贋確認が必要なケースまで考えられるため、タグ番号だけで即断せず、品質表示・縫製・素材・アイテム内容と合わせて確認します。",
      },
      {
        index: "00",
        title: "0｜Artisanal / アーティザナル",
        text:
          "手作業による再構築や一点物に近い作品を示す、Maison Margielaの中でも特にアーカイブ価値が語られやすい番号です。\n古着や既製服を解体し、別の服へ作り替える思想が強く表れます。\n買取視点：0番、0 10番、アーティザナル表記、再構築性の強い作品は、必ず写真付きで事前査定したい領域です。",
      },
      {
        index: "01",
        title: "1｜Women's Collection / ウィメンズコレクション",
        text:
          "Maison Margielaのウィメンズメインコレクションを示す番号です。\n解体、再構築、匿名性、テーラリング、ドレス的な表現など、ブランドの中核的な思想が現れます。\n買取視点：本人期・旧Maison Martin Margiela期の1番は、年代やデザインによってアーカイブ評価が変わります。",
      },
      {
        index: "02",
        title: "2｜Unassigned / 未使用・割当なし",
        text:
          "通常の主要ラインとしては明確な割当がない番号です。\nタグ上では数字として存在しますが、丸が付く主要カテゴリーとして見る機会は多くありません。\n買取視点：2番に丸がある場合は、真贋やタグ仕様を含めて慎重に確認した方がよいです。",
      },
      {
        index: "03",
        title: "3｜Fragrances / フレグランス",
        text:
          "香水・フレグランスを示す番号として整理されるカテゴリーです。\nMaison MargielaではReplicaフレグランスなど、香りの記憶をテーマにした展開も知られています。\n買取視点：衣類買取では主対象になりにくい番号ですが、ブランド全体のカテゴリー理解として押さえておくと便利です。",
      },
      {
        index: "04",
        title: "4｜Women's Wardrobe / ウィメンズワードローブ",
        text:
          "ウィメンズのワードローブ、日常着に近いラインを示す番号です。\nメインコレクションよりも生活に近い服として、ニット、ジャケット、シャツ、パンツなどに見られます。\n買取視点：派手なアーカイブではなくても、状態の良い定番品や需要のあるアイテムは査定対象になります。",
      },
      {
        index: "05",
        title: "5｜Unassigned / 未使用・割当なし",
        text:
          "通常の主要ラインとしては明確な割当がない番号です。\nタグ上には存在しますが、丸が付いて流通するアイテムは一般的ではありません。\n買取視点：5番のみが丸で囲まれている場合は、タグの整合性を確認する必要があります。",
      },
      {
        index: "06",
        title: "6｜MM6 Maison Margiela",
        text:
          "MM6 Maison Margielaを示す番号です。\nメインラインよりも日常的・コンテンポラリーな文脈が強く、Tシャツ、ワンピース、バッグ、シューズなど幅広く展開されます。\n買取視点：MM6も査定対象ですが、メインラインやアーティザナルとは評価軸が異なります。",
      },
      {
        index: "07",
        title: "7｜Unassigned / 未使用・割当なし",
        text:
          "通常の主要ラインとしては明確な割当がない番号です。\n数字タグの構造上は存在しますが、一般的な衣類カテゴリーとしては使われにくい番号です。\n買取視点：タグ番号とアイテム種別に違和感がある場合は、真贋確認が重要です。",
      },
      {
        index: "08",
        title: "8｜Eyewear / アイウェア",
        text:
          "アイウェアを示す番号として整理されます。\nサングラスや眼鏡など、衣類とは異なるアクセサリー領域のカテゴリーです。\n買取視点：アパレルと同じ基準ではなく、付属品・状態・型番・市場需要を確認します。",
      },
      {
        index: "09",
        title: "9｜Unassigned / 未使用・割当なし",
        text:
          "通常の主要ラインとしては明確な割当がない番号です。\n0から23まで数字は並びますが、すべての番号が常に主要ラインとして使われるわけではありません。\n買取視点：番号そのものより、タグ仕様・品質表示・縫製・アイテム内容の整合性を見る必要があります。",
      },
      {
        index: "10",
        title: "10｜Men's Collection / メンズコレクション",
        text:
          "Maison Margielaのメンズメインコレクションを示す番号です。\nジャケット、コート、シャツ、パンツ、ニットなど、メンズの中心的なラインとして古着市場でも見かけやすい番号です。\n買取視点：旧Maison Martin Margiela期、本人期、再構築性のある10番は、アーカイブとして丁寧に確認したい領域です。",
      },
      {
        index: "11",
        title: "11｜Accessories / アクセサリー",
        text:
          "アクセサリーを示す番号です。\nベルト、財布、バッグ、小物など、衣服以外のカテゴリーに関わる番号として理解できます。\n買取視点：状態、素材、付属品、需要のあるモデルかどうかを確認します。",
      },
      {
        index: "12",
        title: "12｜Fine Jewellery / ファインジュエリー",
        text:
          "ジュエリー関連のカテゴリーとして整理される番号です。\n衣類よりも素材・状態・付属品・販売証明などの確認が重要になります。\n買取視点：ジュエリー類は素材価値とブランド価値の両方を分けて見る必要があります。",
      },
      {
        index: "13",
        title: "13｜Objects & Publications / オブジェ・出版物",
        text:
          "オブジェや出版物など、服以外の表現を示す番号です。\nMaison Margielaは衣服だけでなく、空間、物、出版物を通じてもブランドの世界観を表現してきました。\n買取視点：希少なノベルティ、書籍、オブジェ類は、状態と流通量によって価値が変わります。",
      },
      {
        index: "14",
        title: "14｜Men's Wardrobe / メンズワードローブ",
        text:
          "メンズのワードローブラインを示す番号です。\n10番がメンズメインコレクションであるのに対し、14番はより日常的なメンズウェアに近い位置づけとして理解しやすい番号です。\n買取視点：10番と14番は混同されやすいため、タグ番号とアイテム内容をセットで見ることが重要です。",
      },
      {
        index: "15",
        title: "15｜Collaboration / 3 Suissesなど",
        text:
          "過去のコラボレーションや特定企画に関わる番号として語られることがあります。\n一般的な衣類ラインとして頻繁に見かける番号ではありません。\n買取視点：希少企画の場合は、タグ番号だけでなくコラボ内容や流通背景を確認します。",
      },
      {
        index: "16",
        title: "16｜Unassigned / 未使用・割当なし",
        text:
          "通常の主要ラインとしては明確な割当がない番号です。\n数字が存在するからといって、すべてが通常カテゴリーとして使われるわけではありません。\n買取視点：違和感のある番号表示は、タグ全体の整合性確認が必要です。",
      },
      {
        index: "17",
        title: "17｜Unassigned / 未使用・割当なし",
        text:
          "通常の主要ラインとしては明確な割当がない番号です。\nMaison Margielaの数字タグは一覧性が特徴ですが、未使用番号も含まれます。\n買取視点：番号だけで判断せず、品質タグや縫製、素材、年代を合わせて見ます。",
      },
      {
        index: "18",
        title: "18｜Unassigned / 未使用・割当なし",
        text:
          "通常の主要ラインとしては明確な割当がない番号です。\n古着で不自然な丸付き番号がある場合は注意が必要です。\n買取視点：番号とカテゴリーが合っているか、タグの形状・フォント・縫い付け方を確認します。",
      },
      {
        index: "19",
        title: "19｜Unassigned / Used in anonymous period",
        text:
          "一部では、匿名デザインチーム期に関わる番号として言及されることがあります。\nただし、一般ユーザーが最初に覚えるべき主要番号ではありません。\n買取視点：珍しい番号は、年代・タグ仕様・コレクション背景を含めて個別確認が必要です。",
      },
      {
        index: "20",
        title: "20｜Exhibitions / 展示・プロジェクト系",
        text:
          "展示やプロジェクトに関わる番号として整理されることがあります。\n通常の衣類ラインとは異なる文脈で理解した方がよい番号です。\n買取視点：資料性や限定性がある場合は、通常衣類とは別軸で確認します。",
      },
      {
        index: "21",
        title: "21｜Unassigned / 未使用・割当なし",
        text:
          "通常の主要ラインとしては明確な割当がない番号です。\n数字タグの一覧には含まれますが、頻繁に使われるカテゴリーではありません。\n買取視点：タグ番号だけで価値を決めず、アイテム全体を確認します。",
      },
      {
        index: "22",
        title: "22｜Shoes / シューズ",
        text:
          "シューズを示す番号です。\nTabiブーツ、スニーカー、ローファー、パンプスなど、Maison Margielaを象徴する靴カテゴリーと関係します。\n買取視点：Tabi、Replica、人気シューズは状態・サイズ・付属品・現行需要によって査定が大きく変わります。",
      },
      {
        index: "23",
        title: "23｜Unassigned / 未使用・割当なし",
        text:
          "通常の主要ラインとしては明確な割当がない番号です。\n0から23までの数字が並ぶことで、分類表のような匿名的な印象を作ります。\n買取視点：珍しい表示や違和感のあるタグは、真贋と年代の確認が必要です。",
      },
      {
        index: "FAQ",
        title: "白タグなら初期マルジェラ、または高額品と考えていい？",
        text:
          "そうとは限りません。\n番号プリントのない白タグは、初期Maison Martin Margielaを考えるうえで重要な仕様ですが、現在・近年のMaison Margielaにも無地に近い白タグが見られることがあります。\nそのため、白タグだけで年代や価値を判断するのは危険です。\nEnclopediaでは、白タグ、数字タグ、複数番号の丸付きタグを含め、品質表示、縫製、素材、アイテム内容、現在の需要まで見て査定します。",
      },
    ],
    quote:
      "Maison Margielaの数字タグは、ブランド名を叫ばない。だからこそ、知っている人には深く刺さる。",
    perspectiveTitle:
      "Enclopediaは、数字タグを“知識”から“買取相談”へつなげる。",
    perspectiveCards: [
      {
        number: "01",
        title: "KNOWLEDGE",
        text:
          "0、1、4、6、10、14、22などの番号を知ることで、Maison Margielaの服がどのラインに属するかを読み解けます。",
      },
      {
        number: "02",
        title: "ARCHIVE VALUE",
        text:
          "本人期、旧Maison Martin Margiela期、Artisanal、Tabi、5ACなどは、タグ番号・年代・状態を合わせて見ることで価値判断の精度が上がります。",
      },
      {
        number: "03",
        title: "BUYBACK",
        text:
          "タグ番号が分かる写真、品質表示、全体像、ディテールをLINEで送ることで、宅配買取へ進む前に事前査定の精度を高められます。",
      },
    ],
    experienceTitle:
      "マルジェラを売る前に、タグ番号を確認する。",
    experienceBody:
      "Maison Margielaの買取では、ブランド名だけでなく、タグ番号・年代・ライン・アイテム種別・状態が重要です。\n特に0番のArtisanal、1番のウィメンズメインライン、10番のメンズコレクション、14番のメンズワードローブ、22番のシューズは、査定時に確認したいポイントです。\n加えて、数字タグ導入以前の無地白タグ、現在・近年品にも見られる番号プリントのない白タグ、1と10のように複数番号に丸が付いているタグ、0 10表記などは、アーカイブ性や真贋確認の面でも重要です。\nただし、白タグや複数丸タグだけで価値が決まるわけではありません。タグ、品質表示、デザイン、状態、流通量を合わせて見ることで、売却前の相談がスムーズになります。",
    experienceItems: [
      "白い数字タグの丸付き番号を確認する",
      "1と10など、複数番号に丸が付いていないか確認する",
      "番号プリントのない白タグかどうか確認する",
      "品質表示タグ・品番・生産国を撮影する",
      "Tabiや5ACなどモデル名が分かる場合は伝える",
      "本人期・旧Maison Martin Margiela期と思われる場合は年代が分かる写真を送る",
    ],
    archiveItemsTitle:
      "Maison Margielaの価値を、買取相談へつなげる。",
    archiveItemsBody:
      "Enclopediaでは、Maison Margielaを単なるブランド名ではなく、タグ番号・ライン・年代・アーカイブ性まで見て査定します。売却前にLINEで写真を送ることで、宅配買取へ進む前におおまかな方向性を確認できます。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "Maison Margiela買取ページへ",
        productPath: "/brand_buyback/maison-margiela",
        productImage: "",
        text:
          "本人期、アーティザナル、Tabi、5AC、八の字ライダース、MM6まで。Maison Margielaの買取対象と査定視点を詳しく確認できます。",
      },
      {
        label: "BUYBACK FOCUS 02",
        title: "LINEでマルジェラを事前査定",
        productPath: "https://line.me/R/ti/p/@240yzqkh",
        productImage: "",
        text:
          "数字タグ、品質表示、全体写真、ディテール写真を送るだけで、宅配買取へ進む前におおまかな査定方向を確認できます。",
      },
      {
        label: "BUYBACK FOCUS 03",
        title: "宅配買取を申し込む",
        productPath: "/kaitori/takuhai",
        productImage: "",
        text:
          "事前査定後、売却を進めたい場合は宅配買取へ。送料や流れを確認しながら、Maison MargielaをEnclopediaへお送りいただけます。",
      },
    ],
    finalCta: {
      title:
        "Maison Margielaのタグ番号を確認したら、次は価値を相談する。",
      body:
        "0番、10番、14番、22番。数字タグは、その一着の文脈を読む手がかりです。\n白タグ、複数番号の丸付きタグ、本人期、アーティザナル、Tabi、5AC、MM6まで、まずはLINEで写真をお送りください。",
      buttonLabel: "Maison MargielaをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };

export default collection;
